<script>
  import { createEventDispatcher } from "svelte";
  import { clickOutside, textToId } from "$lib/utilities/dom-helpers";
  import Button from "./Button.svelte";
  import Heading from "./Heading.svelte";

  export let name;
  export let label;
  export let options = [];
  export let defaultValue = options[0]?.value;
  export let expanded = false;

  function toggle(bool = false) {
    expanded = bool;
  }

  let firstOptionHovered = false;
  let firstOptionFocused = false;
  function createHoverHandler(idx, bool) {
    return idx === 0 ? () => (firstOptionHovered = bool) : null;
  }
  function createFocusHandler(idx, bool) {
    return idx === 0 ? () => (firstOptionFocused = bool) : null;
  }

  let selected = defaultValue;
  const dispatch = createEventDispatcher();
  function createSelectHandler(option) {
    return (evt) => {
      evt.stopPropagation();
      toggle();
      selected = option.value;
      dispatch("select", {
        name,
        option
      });
    };
  }
</script>

<div class="relative first-of-type:z-10" use:clickOutside={() => toggle()}>
  <Heading class="heading-5 text-size-12 pb-8" text={label} />

  <div class="max-w-fit">
    <Button
      variant="ghost"
      size="small"
      class="!text-size-14 !font-bold"
      aria-haspopup
      aria-expanded={expanded}
      on:click={() => toggle(!expanded)}
      icon={{ type: expanded ? "chevron-up" : "chevron-down", size: "md", trailing: true }}
    >
      <span class="text-left line-clamp-1">
        {options.find((opt) => opt.value === selected)?.label}
      </span>
    </Button>
  </div>

  <div
    class="absolute flex flex-col justify-center items-center left-0 right-0"
    style="margin-top:12px;"
    class:hidden={!expanded}
  >
    <div
      class="z-50 flex h-24 w-24 border border-r-0 border-b-0 border-neutral-300 -mb-10"
      style="transform: rotate(45deg);"
      class:bg-white={!firstOptionHovered && !firstOptionFocused}
      class:bg-indigo-50={firstOptionHovered}
      class:bg-highlight={firstOptionFocused}
    >
      &nbsp;
    </div>

    <div class="self-start md:self-center flex flex-col justify-center items-center min-w-max">
      <ul
        class="list-none bg-white text-size-14 font-bold border border-neutral-300 -mt-2 max-w-[315px] md:min-w-max md:w-auto"
        aria-labelledby={textToId(label)}
      >
        {#each options as opt, idx}
          <li
            aria-current={opt.value === selected}
            on:mouseenter={createHoverHandler(idx, true)}
            on:mouseleave={createHoverHandler(idx, false)}
            on:focusin={createFocusHandler(idx, true)}
            on:focusout={createFocusHandler(idx, false)}
          >
            <button
              class="w-full text-left p-24 hover:bg-indigo-50 focus:outline-none focus:bg-highlight focus:shadow-dropdown-hover active:bg-indigo-50 active:shadow-dropdown-hover"
              on:click={createSelectHandler(opt)}
            >
              {opt.label}
            </button>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</div>
